module.exports = __webpack_public_path__ + "static/img/First_screen_image_Main_02-03.6748200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/First_screen_image_Main_02-03.jpg
// module id = g58o
// module chunks = 1